import * as updateSystemActionType from '@/constants/updateSystemActionType';

export function setStatusSystemUpdate(response) {
  return {
    type: updateSystemActionType.STATUS_SYSTEM_UPDATE,
    value: response,
  };
}

export function setInstallSystemUpdate(response) {
  return {
    type: updateSystemActionType.INSTALL_SYSTEM_UPDATE,
    value: response,
  };
}

export function setCancelDownloadBinaryUpdate(response) {
  return {
    type: updateSystemActionType.CANCEL_DOWNLOAD_BINARY_UPDATE,
    value: response,
  };
}

export function setStatusDownloadBinaryUpdate(response) {
  return {
    type: updateSystemActionType.STATUS_DOWNLOAD_BINARY_UPDATE,
    value: response,
  };
}

export function setDownloadBinaryUpdate(response) {
  return {
    type: updateSystemActionType.DOWNLOAD_BINARY_UPDATE,
    value: response,
  };
}

export function setCheckVersionSystem(response) {
  return {
    type: updateSystemActionType.CHECK_VERSION_SYSTEM,
    value: response,
  };
}
export function setSystemUpdatePending() {
  return {
    type: updateSystemActionType.SYSTEM_UPDATE_PENDING,
  };
}
export function setReleaseNotes(response) {
  return {
    type: updateSystemActionType.RELEASE_NOTES,
    value: response,
  };
}
export function isMinimizeUpdate(response) {
  return {
    type: updateSystemActionType.IS_MINIMIZE_UPDATE,
    value: response,
  };
}
export function isRestartLater(response) {
  return {
    type: updateSystemActionType.IS_RESTART_LATER,
    value: response,
  };
}

export function setUpdateSWStatus(value) {
  return {
    type: updateSystemActionType.SET_UPDATE_SW_STATUS,
    value,
  };
}
